import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTachometerAlt, FaTable, FaChevronDown, FaChevronUp } from "react-icons/fa";
import Logo from "../assets/NanoPulseLogo1.png";

const Sidebar = () => {
  const navigate = useNavigate();
  return (
    <div style={styles.sidebar}>
      <div style={styles.logoContainer}>
        <img src={Logo} alt="logo" style={styles.logoImg} />
      </div>

      <div style={styles.menu}>
        <MenuItem
          icon={<FaTachometerAlt />}
          text="Dashboard"
          onClick={() => navigate("/admin/dashboard")}
        />

        <MenuItem icon={<FaTable />} text="Manage Clients" dropdown>
          <SubMenuItem
            text="List of Client"
            onClick={() => navigate("/admin/table/clients")}
          />
          <SubMenuItem
            text="Partner Request"
            onClick={() => navigate("/admin/table/partners")}
          />
        </MenuItem>
      </div>
    </div>
  );
};

const MenuItem = ({ icon, text, children, dropdown, onClick }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div
        style={styles.menuItem}
        onClick={() => {
          if (dropdown) {
            setOpen(!open);
          } else if (onClick) {
            onClick();
          }
        }}
      >
        {icon}
        <span style={{ marginLeft: 10, flex: 1 }}>{text}</span>
        {dropdown && (open ? <FaChevronUp /> : <FaChevronDown />)}
      </div>

      {dropdown && open && <div style={styles.subMenu}>{children}</div>}
    </div>
  );
};

const SubMenuItem = ({ text, onClick }) => (
  <div style={styles.subMenuItem} onClick={onClick}>
    {text}
  </div>
);

const styles = {
  sidebar: {
    width: "220px",
    height: "100vh",
    background: "#2f4050",
    color: "#fff",
    padding: "0",
    position: "fixed",
    top: 0,
    left: 0,
    borderRight: "1px solid #2F4050",
  },

  logoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "0px",
    paddingBottom: "10px",
    marginBottom: "10px",
    width: "100%",
  },

  logoImg: {
    width: "220px",
    height: "auto",
    objectFit: "contain",
    marginBottom: "0",
  },

  logoText: {
    fontSize: "18px",
    fontWeight: "500",
    letterSpacing: "1px",
    color: "#fff",
    marginTop: "2px",
  },

  menu: {
    marginTop: "10px",
  },

  menuItem: {
    padding: "10px 15px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
    transition: "background 0.3s",
  },

  subMenu: {
    paddingLeft: "25px",
    display: "flex",
    flexDirection: "column",
    background: "#394a59",
  },

  subMenuItem: {
    padding: "8px 0",
    cursor: "pointer",
    color: "#ddd",
    transition: "color 0.2s",
  },
};

export default Sidebar;